import React, {useEffect, useState, Component} from 'react';

import Switch from '@material-ui/core/Switch';
import { Link } from 'react-router-dom';
import FirebaseService from '../../services/firebase';
import './style.css';
import { Grid, Typography } from '@material-ui/core';
import Contacts from './components/contacts';
import Chat from './components/chat';

import messageSound from '../../assets/notification.mp3';
import UserDetail from './components/user-detail';

export default class ChatPage extends Component {

    audio = new Audio(messageSound)

    constructor(props) {
        super(props);
        this.state = {
            user: FirebaseService.getCurrentUser(),
            contacts: [],
            chat: {}
        }; 

        this.selectChat = this.selectChat.bind(this);
        let contacts = localStorage.getItem('contacts');
        if (contacts) this.setState({contacts: JSON.parse(contacts)});

        FirebaseService.subscribeContacts(this.handleContacts.bind(this))
    }

    handleContacts(snapshot) {
        console.log("playing")
        let contacts = snapshot.docs.map(item => item.data());
        this.setState({contacts: contacts});

        console.log("playing", this.audio)
        console.log(contacts[0].lastMessage.toDate())
        this.audio.currentTime = 0;
        if (contacts[0].unreadMessages > 0) this.audio.play();

        localStorage.setItem('contacts', JSON.stringify(contacts));
    }

    selectChat = (contactData) => {
        console.log('contact data', contactData)
        this.setState({contactData})
    }
    
    play = () => {
        this.audio.currentTime = 0;
        this.audio.play();
    }

    render() {
        return (
            <div className="chat-page-component">
                <Contacts contacts={this.state.contacts} select={this.selectChat}/>
                <Chat contactData={this.state.contactData}/>
                <UserDetail contactId={this.state.contactData?.contactId}/>
            </div>
        )
    }
}